import { Module } from "vuex";
import { TelemetryEntry, TelemetryEntryMetadata, TelemetryStatus, TelemetryStoreStateInterface } from "@/store-services/telemetry.types";

export const UPDATE_DATA = "UPDATE_DATA";
export const UPDATE_STATUS = "UPDATE_STATUS";
export const CLEAR_DATA = "CLEAR_DATA";

export const telemetryStore: Module<TelemetryStoreStateInterface, any> = {
  namespaced: true,
  state: {
    values: [],
    status: {
      text: "Socket offline",
      number: -1,
      time: {
        last: new Date(),
        delay: null,
        delayCritical: true,
        current: new Date()
      }
    }
  },
  mutations: {
    [CLEAR_DATA](state) {
      state.values = [];
    },
    [UPDATE_DATA](state, payload: Array<TelemetryEntry>) {
      for (let ent of payload) {
        let idx = state.values.findIndex((e) => e.id === ent.id);
        if (idx > -1) {
          state.values.splice(idx,1, ent);
        } else {
          state.values.push(ent);
        }
      }
    },
    [UPDATE_STATUS](state, payload: Partial<TelemetryStatus>) {
      state.status = {...state.status, ...payload};
    }
  },
  actions: {

  },
  getters: {
    getStatus: (state) => () => {
      return state.status;
    },
    getValue: (state) => (id?: string | Array<string>): TelemetryEntry | Array<TelemetryEntry> | undefined => {
      if (id) {
        if (Array.isArray(id)) {
          let result = new Array<TelemetryEntry>();
          for (let i of id) {
            let ent = state.values.find((e) => e.id === i);
            if (ent) {
              result.push(ent);
            }
          }
          return result;
        } else {
          return state.values.find((e) => e.id == id);
        }
      } else {
        return state.values;
      }
    },
    getValues: (state) => () => {
      return state.values;
    }
  }
}